import React from 'react';
import Footer from '../components/footer';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import poops from '../../assets/case1.png';
import lf from '../../assets/lf.png';
import churro from '../../assets/logo-01.png';
import thelot from '../../assets/case4.png';
import Header from '../menu/header2';
import Cyber from '../../assets/cyber.png'
import { Link } from "@reach/router";


const CaseStudies = () => (
  <div>
    <Header/>
    <section style={{ paddingTop: '10em', backgroundColor: 'black' }}>
      <Container>
       
        <Row>
         
        <Col xs={12} md={7}>
           
                     <iframe width="560" height="315" src="https://www.youtube.com/embed/5ZdZ2F-6PE8?si=SzZie9tlmTTi8LYv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              
               
               
               
          
            
          </Col>







          <Col xs={12} md={4}>
            <Link to="/techdemo">
              <img
                src={Cyber}
                alt="DAO Social Media - Current Project in progress"
                style={{
                  width: '75%',
                  height: '15em',
                  objectFit: 'cover',
                  borderRadius: '10px',
                  boxShadow: '3px 3px 5px rgba(0, 0, 0, 0.3)',
                  backgroundColor: 'white',
                }}
              />
            </Link>
            <p style={{ color: 'white', textAlign: 'center' }}>
             Interactive Digital Experience Tech Demo
            </p>
          </Col>

       
       


          
         
         

          <Col xs={12} md={4}>
            {/* Empty column to maintain the three-column layout on desktop */}
          </Col>
        </Row>
      </Container>
    </section>

    <Footer />
  </div>
);

export default CaseStudies;
